export default "__VITE_ASSET__BlG7mKOl__"